import { Link } from 'react-router-dom';
import { initialOf, t } from '../../i18n';
import { jaPath } from './labels';

// Eintrag „Jahresabschluss“ in der Liste der Bereiche auf der Übersicht
export function JaListItem({ clientId }: { clientId: string }) {
  return (
    <Link className="item" to={jaPath(clientId)}>
      <span className="ico" aria-hidden="true">
        {initialOf('Jahresabschluss')}
      </span>
      <span className="tx">
        <b>{t('Jahresabschluss')}</b>
        <small>{t('Bilanz, GuV und Steuererklärungen pro Jahr')}</small>
      </span>
      <span className="chev" aria-hidden="true">
        ›
      </span>
    </Link>
  );
}
